import { render } from "./support.vue?vue&type=template&id=a6e9a888&scoped=true&ts=true&lang=pug"
import script from "./support.vue?vue&type=script&lang=ts"
export * from "./support.vue?vue&type=script&lang=ts"

import "./support.vue?vue&type=style&index=0&id=a6e9a888&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e9a888"]])

export default __exports__